import React, { useEffect, useState } from 'react';
import { Box, Chip, Grid, Paper, Tooltip, Typography } from '@mui/material';
import { WarningAmberOutlined } from '@mui/icons-material';
import api from '../../api';
import FilamentStockBar from './FilamentStockBar';
import { ColorSwatchLabel } from '../HtmlColorField';
import { filamentLabel } from '../../helpers/filaments';

/**
 * Destaque dos carretéis que estão acabando. O backend monta a lista cacheada,
 * exclui arquivados e só devolve quem está abaixo do limite de estoque baixo.
 */
function FilamentLowStockPanel({ reloadKey, onSelect }) {
    const [filaments, setFilaments] = useState([]);

    useEffect(() => {
        let active = true;
        api.get('filaments/low-stock')
            .then((response) => {
                if (active) {
                    setFilaments(response.data?.materials || []);
                }
            })
            .catch(() => {
                if (active) {
                    setFilaments([]);
                }
            });
        return () => {
            active = false;
        };
    }, [reloadKey]);

    if (filaments.length === 0) {
        return null;
    }

    const depleted = filaments.filter((item) => (Number(item.current_weight) || 0) <= 0).length;

    return (
        <Paper variant="outlined" sx={{ p: 2, mb: 2, borderColor: 'warning.main' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5, flexWrap: 'wrap' }}>
                <WarningAmberOutlined color="warning" />
                <Typography variant="subtitle1" fontWeight={700}>
                    Estoque baixo
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {filaments.length === 1
                        ? '1 carretel precisa de atenção'
                        : `${filaments.length} carretéis precisam de atenção`}
                    {depleted > 0 && (depleted === 1 ? ', 1 já sem saldo' : `, ${depleted} já sem saldo`)}
                </Typography>
            </Box>

            <Grid container spacing={2}>
                {filaments.map((filament) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={filament.id || filament.uuid}>
                        <Tooltip title="Abrir para repor o saldo">
                            <Box
                                onClick={() => onSelect?.(filament)}
                                sx={{
                                    cursor: onSelect ? 'pointer' : 'default',
                                    p: 1,
                                    borderRadius: 1,
                                    '&:hover': { bgcolor: onSelect ? 'action.hover' : undefined },
                                }}
                            >
                                <Typography variant="body2" component="div" noWrap>
                                    <ColorSwatchLabel
                                        color={filament.color}
                                        label={filamentLabel(filament) || filament.color_label}
                                    />
                                </Typography>
                                <FilamentStockBar
                                    currentWeight={filament.current_weight}
                                    spoolWeight={filament.spool_weight}
                                />
                                {(filament.usage_count || 0) > 0 && (
                                    <Chip
                                        size="small"
                                        variant="outlined"
                                        label={filament.usage_count === 1
                                            ? '1 impressão'
                                            : `${filament.usage_count} impressões`}
                                        sx={{ mt: 0.5 }}
                                    />
                                )}
                            </Box>
                        </Tooltip>
                    </Grid>
                ))}
            </Grid>
        </Paper>
    );
}

export default FilamentLowStockPanel;
